export default __webpack_public_path__ + "static/headstand-onelegup-1-46ee60cb6100a3cc679dedde38278b7b.jpg";